import * as React from 'react';
import * as styles from './navigation.module.scss';
import Navigation from '../../../../models/navigation';
import List from '@material-ui/core/List';
import CateogryListItem from './categoryListItem';
import Scrollbars from 'react-custom-scrollbars';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import Dashboard from '../../../../models/Dashboard';

interface Props {
  navigations: Navigation[];
  clientDashboards: Dashboard[];
  updateDashboardNavigation: (navigation: Navigation) => void;
  updateCategoryNavigation: (navigation: Navigation) => void;
  deleteCategory: (navigationId: number) => void;
  deleteDashboard: (navigation: Navigation) => void;
  scrollRef: React.MutableRefObject<any>;
}

/**
 * Component which contains the section for navigation categories
 */
const NavList = ({
  navigations,
  clientDashboards,
  updateDashboardNavigation,
  updateCategoryNavigation,
  deleteCategory,
  deleteDashboard,
  scrollRef
}: Props) => {
  return (
    <React.Fragment>
      <div className={styles.navListHeader}>
        <p>Name</p>
      </div>
      <Scrollbars autoHide style={{ flex: 1 }} ref={scrollRef}>
        <Droppable droppableId="droppable-top-level" type="CATEGORY">
          {(provided, snapshot) => (
            <List className={styles.navList} ref={provided.innerRef} {...provided.droppableProps}>
              {navigations.map(navigation => (
                <Draggable
                  draggableId={`${navigation.navigationId}`}
                  index={navigation.seqOrder}
                  key={navigation.navigationId}
                >
                  {provided => (
                    <CateogryListItem
                      navigation={navigation}
                      provided={provided}
                      clientDashboards={clientDashboards}
                      updateDashboardNavigation={updateDashboardNavigation}
                      updateCategoryNavigation={updateCategoryNavigation}
                      deleteCategory={deleteCategory}
                      deleteDashboard={deleteDashboard}
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </Scrollbars>
    </React.Fragment>
  );
};

export default NavList;
